import React, { Fragment, useEffect, useState } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Row, Col, Divider, InputNumber } from "antd";
import { useAppSelector } from "store/hook";
import { setFields, SYSTEMProps } from "./setField";

const { Option } = Select;

const M350Type = [
  { value: "sms", name: "SMS" },
  { value: "vpn-disconnect", name: "VPN disconnect" },
  { value: "wan-disconnect", name: "WAN disconnect" },
  { value: "reboot", name: "Reboot" },
  { value: "lan-eth-disconnect", name: "LAN disconnect" },
  { value: "di", name: "DI" },
  { value: "geofence", name: "Geofence" },
];

const AlarmM350 = React.memo(({ SubmitConfigonFinish, form }: SYSTEMProps) => {
  const [AlarmEnable, setAlarmEnable] = useState<boolean>(false);
  const [AlarmType, setAlarmType] = useState<string[]>([]);
  const [GPSReference, setGPSReference] = useState(false);
  const { formData, importSource } = useAppSelector((state) => state.topology);
  const hasGPS = formData?.system?.alarm?.inputs?.includes("geofence");

  const alarm = formData?.system?.alarm;

  useEffect(() => {
    setAlarmEnable(alarm?.mode || false);
    setGPSReference(alarm?.geofence?.auto_detect);
    setAlarmType(alarm?.inputs);

    if (importSource === "NewConfig") {
      return;
    }

    setFields(alarm, form);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
      <div className="formwrap">
        <Row gutter={24} justify="space-around">
          <Col xs={24} sm={24} md={24} lg={24} xl={10}>
            <h2>Type</h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"alarm_enabled"}
              label="Alarm Enable"
              rules={[{ required: true, message: "required!" }]}
              initialValue={false}
              // dependencies={['alarm_input']}
            >
              <Select
                onChange={(value: any) => {
                  setAlarmEnable(value);
                  form.validateFields(["alarm_input", "gps_radius", "gps_latitude", "gps_longitude"]);
                }}
                placeholder={"ON/OFF"}
              >
                {/* @ts-ignore */}
                <Option key={0} value={true}>
                  ON
                </Option>
                {/* @ts-ignore */}
                <Option key={1} value={false}>
                  OFF
                </Option>
              </Select>
            </Form.Item>

            <Form.Item
              name={"alarm_input"}
              label="Type"
              rules={[{ required: AlarmEnable, message: "required!" }]}
              initialValue={["sms"]}
              // validateTrigger={['alarm_enabled']}
            >
              <Select
                onChange={(value: string[]) => {
                  setAlarmType(value);
                  form.validateFields(["gps_radius", "gps_latitude", "gps_longitude"]);
                }}
                mode="multiple"
                maxTagCount={"responsive"}
                placeholder={"GPS, SMS ...."}
                disabled={!AlarmEnable}
              >
                {M350Type.map((item, index) => {
                  // 開啟會導致設備若沒有選geofence則不會顯示此選項不能選 (5/10待確認)
                  if (item.value === "geofence" && !hasGPS) {
                    return;
                  }
                  return (
                    <Option key={index} value={item.value}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={10}>
            <h2>GPS Detection</h2>
            <Divider className={styles.divider} />
            <Form.Item
              name={"gps_radius"}
              label="Radius(m)"
              rules={[
                {
                  required: AlarmType?.includes("geofence") && AlarmEnable,
                  message: "required!",
                },
                {
                  type: "number",
                  max: 100000,
                  min: 100,
                  message: "Radius range should be 100-100000",
                },
              ]}
              initialValue={150}
              tooltip={"Issue an alert when device is out of range"}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="100~100000"
                disabled={!AlarmEnable || !AlarmType?.includes("geofence")}
              />
            </Form.Item>

            <Form.Item
              name="gps_reference"
              label="Reference"
              rules={[
                {
                  required: AlarmType?.includes("geofence"),
                  message: "required!",
                },
              ]}
              initialValue={true}
              tooltip={"Setting device location by manual input/Auto detect by GPS"}
            >
              <Select
                disabled={!AlarmEnable || !AlarmType?.includes("geofence")}
                onChange={(value: any) => {
                  setGPSReference(value);
                }}
                placeholder={"Manual/Auto"}
              >
                {/* @ts-ignore */}
                <Option key={0} value={true}>
                  Auto Detect
                </Option>
                {/* @ts-ignore */}
                <Option key={1} value={false}>
                  Self Define
                </Option>
              </Select>
            </Form.Item>
            {GPSReference === false && (
              <Fragment>
                <Form.Item
                  name={"gps_latitude"}
                  label="Latitude"
                  rules={[
                    {
                      required: AlarmType?.includes("geofence") && AlarmEnable,
                      message: "required!",
                    },
                    {
                      type: "float",
                      message: "Input must be floating-point number",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    // precision={0.00001}
                    max={89.999999}
                    min={-89.999999}
                    placeholder="-90~90"
                    disabled={!AlarmType?.includes("geofence") || !AlarmEnable}
                  />
                </Form.Item>
                <Form.Item
                  name={"gps_longitude"}
                  label="Longitude"
                  rules={[
                    {
                      required: AlarmType?.includes("geofence") && AlarmEnable,
                      message: "required!",
                    },
                    {
                      type: "float",
                      message: "Input must be floating-point number",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    // precision={0.00001}
                    max={179.999999}
                    min={-179.999999}
                    placeholder="-180~180"
                    disabled={!AlarmType?.includes("geofence") || !AlarmEnable}
                  />
                </Form.Item>
              </Fragment>
            )}
          </Col>
        </Row>
      </div>
    </Form>
  );
});

export default AlarmM350;

////////////////////////////////////////////

export function assemble(values: any) {
  let alarm: any = {
    mode: values.alarm_enabled,
    geofence: {
      radius_m: values.gps_radius || 150,
      auto_detect: values.gps_reference || false,
    },
  };

  if (values.alarm_enabled) {
    alarm.inputs = values.alarm_input;
  } else {
    alarm.inputs = ["geofence"];
  }

  if (!values.gps_reference) {
    alarm.geofence.latitude = values.gps_latitude || 10.123456;
    alarm.geofence.longitude = values.gps_longitude || 10.123456;
  }

  const system = {
    alarm: alarm,
  };

  return system;
}
